import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifEditCollect: {
      type: Boolean,
      default: false // 新增
    },

    collectItem: {
      type: Object,
      default: function _default() {
        return {
          favoriteDesc: null,
          favoriteName: null,
          id: null
        };
      }
    }
  },
  data: function data() {
    return {
      commitBool: false,
      rules: {
        favoriteName: [{
          required: true,
          message: '请输入收藏夹标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '请输入长度在 1 到 50 个字符',
          trigger: 'blur'
        }],
        favoriteDesc: [{
          min: 1,
          max: 500,
          message: '请输入长度在 0 到 500 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('submitCollectFn', {
        bool: false
      });
    },
    commit: function commit(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.submit();
        } else {
          return false;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;
      if (this.commitBool) return;
      if (this.collectItem.favoriteName.trim().length === 0) {
        this.$message({
          message: '收藏夹标题不能为空',
          type: 'warning'
        });
        return;
      }
      if (this.ifEditCollect) {
        // 编辑
        this.commitBool = true;
        this.$API.postRequest({
          url: '/platform/favorite/update',
          data: this.collectItem
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this2.$message({
              message: '编辑收藏夹成功',
              type: 'success'
            });
            _this2.$emit('submitCollectFn', {
              bool: true,
              formData: _this2.collectItem
            });
          }
          _this2.commitBool = false;
        });
      } else {
        // 新增
        this.commitBool = true;
        this.$API.postRequest({
          url: '/platform/favorite/add',
          data: this.collectItem
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this2.$message({
              message: '新建收藏夹成功',
              type: 'success'
            });
            _this2.$emit('submitCollectFn', {
              bool: true,
              formData: _this2.collectItem
            });
          }
          _this2.commitBool = false;
        });
      }
    }
  }
};